var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M14.277 8a6 6 0 1 1-12 0 6 6 0 0 1 12 0m2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-7.673.986H7.58a.24.24 0 0 1-.24-.24v-.531c0-.646.508-1.076.978-1.474.404-.34.778-.658.778-1.066 0-.455-.379-.847-1.01-.847-.598 0-.938.296-1.178.506-.07.06-.13.114-.187.151-.102.063-.19.063-.279-.013l-.593-.58c-.102-.09-.089-.241 0-.33 0 0 .859-1.112 2.477-1.112 1.327 0 2.451.885 2.451 2.124 0 .897-.661 1.42-1.208 1.852-.385.305-.713.564-.713.877v.417c0 .152-.088.266-.252.266m-.519 3.564a1.04 1.04 0 0 1-1.036-1.037c0-.568.468-1.049 1.036-1.049.57 0 1.05.48 1.05 1.05 0 .568-.48 1.036-1.05 1.036",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.277 0h16v16h-16z"
})))));
export default SvgTooltipStandard;